$(document).on('click', '[data-toggle="btn"]', function () {
	const patent = $(this).parents('[data-toggle-init]')[0]

	const content = '[data-toggle="content"]'

	const toggleId = $(patent)?.data('toggle-init')
	const addClass = $(`[data-toggle-${toggleId}]`)
	const className = $(addClass)?.data(`toggle-${toggleId}`)

	const firstText = $(this).data('toggle-first')
	const nextText = $(this).data('toggle-next')

	$(this).toggleClass('is_open')
	$('[data-toggle-text]', this).text(nextText)
	$(addClass)?.addClass(className)
	$(content, patent).slideToggle('200', () => {
		if (!$(this).hasClass('is_open')) {
			$(addClass)?.removeClass(className)
		} else {
			$('[data-toggle-text]', this).text(firstText)
		}
	})
})